/* istanbul ignore next */
const ACTIONS = {
    CREATE_TRIPBOARD_OPEN_MODAL: 'CREATE_TRIPBOARD_OPEN_MODAL',
    CREATE_TRIPBOARD_CLOSE_MODAL: 'CREATE_TRIPBOARD_CLOSE_MODAL',
    CREATE_TRIPBOARD_SHOW_BUTTON: 'CREATE_TRIPBOARD_SHOW_BUTTON'
};

/* istanbul ignore next */
const ACTION_CREATORS = {
    openModal: () => ({type: ACTIONS.CREATE_TRIPBOARD_OPEN_MODAL}),
    closeModal: () => ({type: ACTIONS.CREATE_TRIPBOARD_CLOSE_MODAL}),
    showButton: (tripboardButtonVisible) => ({type: ACTIONS.CREATE_TRIPBOARD_SHOW_BUTTON, payload: {tripboardButtonVisible}})
};

export default {...ACTIONS, ...ACTION_CREATORS};



// WEBPACK FOOTER //
// ./src/universal/tripboard/create-tripboard-controls/actions.js